import { createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7cd77150")

_pushScopeId("data-v-7cd77150")
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "section" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h1", { class: "title" }, "My settings", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("p", null, "Set up Your mattermost ID to revice notifications!", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("label", {
  for: "mattermost-id",
  class: "label"
}, "Mattermost ID", -1)
const _hoisted_7 = { class: "field is-grouped mt-3" }
const _hoisted_8 = { class: "control" }
const _hoisted_9 = {
  key: 0,
  class: "control"
}
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"section\" data-v-7cd77150><h2 class=\"subtitle\" data-v-7cd77150>How to get my Mattermost ID?</h2><ol data-v-7cd77150><li data-v-7cd77150> Go to <a class=\"link\" href=\"https://mattermost.sparing.cloud/\" target=\"_blank\" data-v-7cd77150> mattermost.sparing.cloud <span class=\"icon\" data-v-7cd77150><i class=\"fa fa-external-link-alt\" data-v-7cd77150></i></span></a></li><li data-v-7cd77150>Press <b data-v-7cd77150>F12</b> on your keyboard</li><li data-v-7cd77150>Paste code below to console and hit <b data-v-7cd77150>Enter</b></li></ol><div class=\"pre\" data-v-7cd77150> fetch(&quot;https://mattermost.sparing.cloud/api/v4/users/me&quot;).then(a=&gt;a.json()).then(a=&gt;{console.log(`\\nYour id:\\n\\n%c${a.id}\\n\\n`,&quot;font-size:24px&quot;)}) </div></div>", 1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _createVNode("form", {
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"])),
        class: "form"
      }, [
        _hoisted_6,
        _withDirectives(_createVNode("input", {
          id: "mattermost-id",
          class: "input",
          type: "text",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.mattermostId = $event)),
          placeholder: "ig99fbynuby17cyiwa4g52wn8a",
          minlength: "26",
          maxlength: "26"
        }, null, 512), [
          [_vModelText, _ctx.mattermostId]
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode("div", _hoisted_8, [
            _createVNode("button", {
              class: ["button is-link", { 'is-loading': _ctx.isMattermostIdLoading }],
              type: "submit"
            }, " Save ", 2)
          ]),
          (_ctx.store.state.user.mattermostId.length > 0)
            ? (_openBlock(), _createBlock("div", _hoisted_9, [
                _createVNode("button", {
                  class: ["button is-link is-light", { 'is-loading': _ctx.isMattermostTestMessageLoading }],
                  type: "button",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.mattermostTestMessage && _ctx.mattermostTestMessage(...args)))
                }, " Test message ", 2)
              ]))
            : _createCommentVNode("", true)
        ])
      ], 32)
    ]),
    _hoisted_10
  ]))
})